
// export const BASE_API_URL = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/api' : '';
export const BASE_API_URL = process.env.NODE_ENV === 'development' ? 'http://192.168.0.8:8000/api' : 'https://ramainternationally.com/api';

export const DEFAULT_EMAIL: string = "Info@tarsin.ly"

